var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record"},[_c('div',{staticClass:"record_view"},[_c('div',{staticClass:"record_number"},[_vm._v("粤ICP备2022086636号-1")])])])
}]

export { render, staticRenderFns }